import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSelectModule, MatSelectChange} from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AgCharts } from "ag-charts-angular";
import { AgChartOptions } from "ag-charts-community";
import { Store } from "@ngrx/store";
import {
  selectMonthlyTrendChartOptions,
  selectMonthlyTrendTableRows,
  selectIsMonthlyTrendLoading,
  selectSelectedMonthlyTrendYears,
  selectSelectedMonthlyTrendYearsForm
  } from '@store/selectors/dashboard/dashboard.selectors';
import { Observable, BehaviorSubject, Subject, pipe, tap } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
} from '@angular/forms';
import { ConnectFormDirective } from '@directives/connect-form/connect-form.directive';
import { DashboardActions } from '@store/actions/dashboard/dashboard.actions';
import { getDashboardPerformanceYears } from '@constants/mips-constants';

@Component({
  selector: 'app-measure-monthly-trend',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AgCharts,
    MatSelectModule,
    MatProgressSpinnerModule,
    ConnectFormDirective,
    CommonModule
  ],
  templateUrl: './measure-monthly-trend.component.html',
  styleUrl: './measure-monthly-trend.component.css'
})
export class MeasureMonthlyTrendComponent implements OnInit, OnDestroy {
  public options: any;
  private readonly store = inject(Store);
  private ngUnsubscribe = new Subject<void>();
  private readonly standardFormPipe =  pipe(
        // debounceTime<string>(this.debounceTime),
        distinctUntilChanged<any>(),
        takeUntil(this.ngUnsubscribe)
  );



  form$ = this.store.select(selectSelectedMonthlyTrendYearsForm);

  selectedYears: FormGroup = new FormGroup({
      years: new FormControl(),
  });

  options$ = this.store.select(selectMonthlyTrendChartOptions);
  tableRows$ = this.store.select(selectMonthlyTrendTableRows);
  isLoading$ = this.store.select(selectIsMonthlyTrendLoading);

  selected = [new Date().getFullYear()];


  constructor() {}

  ngOnInit(): void {
    this.selectedYears.controls['years'].valueChanges.pipe(
      this.standardFormPipe
    ).subscribe((value: number[]) => {
      this.store.dispatch(DashboardActions.monthlyTrendMonthsChanged({ years: value }));
    });

    // Have to do it with subscribe
    this.options$.pipe(
     takeUntil(this.ngUnsubscribe)
    ).subscribe((options) => {
      this.options = options
    })
  }

  getYears(): number[] {
    return getDashboardPerformanceYears();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
